/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface P4mClaim
 */
export interface P4mClaim {
    /**
     * Тип клайма
     * @type {string}
     * @memberof P4mClaim
     */
    type?: string | null;
    /**
     * Значение клайма
     * @type {string}
     * @memberof P4mClaim
     */
    value?: string | null;
}

/**
 * Check if a given object implements the P4mClaim interface.
 */
export function instanceOfP4mClaim(value: object): value is P4mClaim {
    return true;
}

export function P4mClaimFromJSON(json: any): P4mClaim {
    return P4mClaimFromJSONTyped(json, false);
}

export function P4mClaimFromJSONTyped(json: any, ignoreDiscriminator: boolean): P4mClaim {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function P4mClaimToJSON(json: any): P4mClaim {
    return P4mClaimToJSONTyped(json, false);
}

export function P4mClaimToJSONTyped(value?: P4mClaim | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
    };
}

